import { storage } from "@/lib/storage";
import { PostSignInResponse } from "@/types";

export const useGetCurrentUser = (): PostSignInResponse | null => {
  return storage.getUser();
};
